(function () {
  var partnerSlidersList2 = document.querySelectorAll('.js_partners_slider_v2');

  for (var i = 0; i < partnerSlidersList2.length; i++) {
    const element = partnerSlidersList2[i];
    const paginationEl = element.closest('.partners-slider__inner').querySelector('.swiper-pagination');
    const navBtnNext = element.closest('.partners-slider__inner').querySelector('.swiper-button-next');
    const navBtnPrev = element.closest('.partners-slider__inner').querySelector('.swiper-button-prev');
    new Swiper(element, {
      spaceBetween: 10,
      slidesPerView: 2,
      centeredSlides: true,
      loop: true,
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 768px
        767: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        // when window width is >= 992px
        991: {
          spaceBetween: 40,
          slidesPerView: 5,
        }
      },
      pagination: {
        el: paginationEl,
        clickable: true,
        dynamicBullets: true,
      },
      navigation: {
        nextEl: navBtnNext,
        prevEl: navBtnPrev,
      },
    });
  }
  ;



})();
